import { State } from '../state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { ExecutionPath } from '../../models';
import { selectBpmnProcessState } from './bpmn-process-state.selector';
import { ListItem } from '@ispm/widgets/models/list-item';
import { isEmpty } from 'lodash';
import { NodeType } from '@ispm/shared/bpmn-io/node-type';
import { Node } from '@ispm-client/modules/process-executor/models';

const getExecutionPath = (state: State): any => state.executionPath;

export const selectExecutionPath: MemoizedSelector<
  object,
  ExecutionPath
  > = createSelector(selectBpmnProcessState, getExecutionPath);

export const selectExecutionPathAsListItems = createSelector(
  selectExecutionPath,
  executionPath => {
    if (!executionPath) {
      return null;
    }

    const executedNodes: Node[] = executionPath.executedNodes ? [...executionPath.executedNodes] : [];

    if (executionPath.currentUserTaskHolder) {
      executedNodes.push(executionPath.currentUserTaskHolder);
    }

    const executedItems: ListItem[] = executedNodes
      .map(
        node => (node.nodeType !== NodeType.neighborhood_head)
          ? { label: node.name, id: node.nodeId}
          : { label: node.name, id: node.nodeId, enable: false}
      );
    const itemToSelect: ListItem = executionPath.currentUserTaskHolder
      ? {
          id: executionPath.currentUserTaskHolder.nodeId,
          label: executionPath.currentUserTaskHolder.name,
          options: executionPath.nodesForSelection.map(node =>  ({ id: node.nodeId, name: node.name})),
          enable: true
        }
      : null;
    const itemsToDisplayAsExecuted = [...executedItems, itemToSelect].filter(item => item != null);

    return isEmpty(itemsToDisplayAsExecuted) ? null : itemsToDisplayAsExecuted;
  }
);

export const selectNodesForSelection = createSelector(
  selectExecutionPath,
  execPath => {
    return !!execPath ? execPath.nodesForSelection : [];
  }
);

